<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-openeds="pathList"
        :unique-opened="true"
        :default-active="activeMenu.path"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :newclass="activeMenu"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      routes: {},
      pathList: [],
    };
  },
  computed: {
    ...mapGetters(["sidebar"]),

    activeMenu() {
      const route = this.$route;
      // //console.log(route);
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      // return '/data/goods/world';

      // if(path.includes('detail')){
      //   return {
      //     path: deleteLastSegmentFromUrl(path),
      //     className: 'is-active'
      //   };
      // }
      function deleteLastSegmentFromUrl(url) {
        const lastSlashIndex = url.lastIndexOf("/");
        if (lastSlashIndex === -1 || lastSlashIndex === url.length - 1) {
          return url;
        }
        return url.substring(0, lastSlashIndex);
      }
      // //console.log(path, "path");

      return {
        path: path,
        className: "is-active",
      };
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  created() {
    const routeName = sessionStorage.getItem("routeName");
    const currentPath = this.$router.history.current.path;
    const ku = currentPath.split("/", 2)[1];
    const routes = this.$router.options.routes;
    //隐藏掉不显示的
    const hiddenPathsMap = {
      chplt: [
        "/cptpp/data",
        "/data",
        "/rcep/data",
        "/monitor",
        "/",
        "/taxrate",
      ],
      cptpp: [
        "/chplt/data",
        "/data",
        "/rcep/data",
        "/chplt/monitor",
        "/chplt/report",
        "/taxrate",
      ],
      rcep: [
        "/cptpp/data",
        "/data",
        "/chplt/data",
        "/chplt/monitor",
        "/chplt/report",
        "/taxrate",
      ],
      default: [
        "/cptpp/data",
        "/rcep/data",
        "/chplt/data",
        "/chplt/monitor",
        "/chplt/report",
      ],
    };

    const key = routeName || ku || "default";
    const hiddenPaths = hiddenPathsMap[key] || hiddenPathsMap.default;

    // 过滤菜单路由
    this.routes = routes.filter((route) => !hiddenPaths.includes(route.path));

    // 构建路径层级（面包屑或导航路径）
    if (currentPath.includes("detail")) {
      const segments = currentPath
        .substring(1)
        .split("/")
        .filter((seg) => seg !== "detail");
      const pathList = [];

      for (let i = 0; i < segments.length; i++) {
        let path = "/" + segments.slice(0, i + 1).join("/") + "/" + segments[i];
        pathList.push(path);
      }

      this.pathList = pathList;
    }
  },
};
</script>
